"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chatChannelAvatarInitials = exports.chatChannelInitials = exports.chatUnreadBadgeText = exports.matchesMember = exports.isChatOrganizationChannel = exports.memberChannelFilters = exports.directMessageChannelData = exports.channelFilters = exports.chatOrganizationId = exports.CHAT_CHANNEL_TYPE = void 0;
/**
 * The one channel type every Duesy channel has (`ChatService::CHANNEL_TYPE`).
 */
exports.CHAT_CHANNEL_TYPE = 'duesy';
/**
 * An organization's chat organization id (`ChatService::organizationId()`): the provider's tenancy unit.
 */
const chatOrganizationId = (organizationId) => `org-${organizationId}`;
exports.chatOrganizationId = chatOrganizationId;
/**
 * The filter every channel query starts from: the Duesy channel type inside the organization.
 * The provider SDK calls the tenancy field `team`; it appears only in this file.
 */
const channelFilters = (organizationId) => ({
    type: exports.CHAT_CHANNEL_TYPE,
    team: (0, exports.chatOrganizationId)(organizationId),
});
exports.channelFilters = channelFilters;
/**
 * The data a client creates a direct message with (ENG-4739): the two members inside the organization and no
 * id, so the provider assigns one, which is how the history store recognises a direct message. The provider SDK
 * calls the tenancy field `team`; it appears only in this file.
 */
const directMessageChannelData = (organizationId, memberIds) => ({
    members: memberIds,
    team: (0, exports.chatOrganizationId)(organizationId),
});
exports.directMessageChannelData = directMessageChannelData;
/**
 * The organization's channels a user is a member of: `channelFilters()` plus their membership. The list, its
 * search and a channel lookup by id all start from it, on the web and in the app.
 */
const memberChannelFilters = (organizationId, userId) => ({
    ...(0, exports.channelFilters)(organizationId),
    members: { $in: [userId] },
});
exports.memberChannelFilters = memberChannelFilters;
/** Whether a channel's data places it in the organization (the provider's tenancy field, read only here). */
const isChatOrganizationChannel = (data, organizationId) => data?.team === (0, exports.chatOrganizationId)(organizationId);
exports.isChatOrganizationChannel = isChatOrganizationChannel;
/** Whether `member` matches what was typed in a staff search. */
const matchesMember = (member, query) => member.name.toLowerCase().includes(query.trim().toLowerCase());
exports.matchesMember = matchesMember;
/** An unread badge's text: at most `99+`, so a long count never widens it. */
const chatUnreadBadgeText = (count) => (count > 99 ? '99+' : String(count));
exports.chatUnreadBadgeText = chatUnreadBadgeText;
/**
 * A named channel's avatar initials on the web and in the app (ENG-4763): the first letters of its first and last
 * words of two or more letters, the web SDK's rule, uppercased: "Kansas City Fastpitch" is "KF". Empty when no word
 * qualifies, and the client then draws its default avatar.
 */
const chatChannelInitials = (name) => {
    const letters = Array.from(name.matchAll(/(\p{L})\p{L}+/gu), (match) => match[1]);
    // One character per word: uppercasing can expand a letter ('ß' is 'SS').
    const initial = (letter) => Array.from((letter ?? '').toUpperCase())[0] ?? '';
    return letters.length > 1
        ? `${initial(letters[0])}${initial(letters[letters.length - 1])}`
        : initial(letters[0]);
};
exports.chatChannelInitials = chatChannelInitials;
/**
 * The initials a channel's avatar draws on the web and in the app (ENG-4763), from the channel's own data: a named
 * channel without an image (a group channel, or an organization channel without a logo). Empty for a channel with an
 * image (the logo) or without a name (a direct message), and the client then draws the SDK's avatar.
 */
const chatChannelAvatarInitials = (data) => {
    if (typeof data?.image === 'string' && data.image !== '')
        return '';
    return typeof data?.name === 'string' ? (0, exports.chatChannelInitials)(data.name) : '';
};
exports.chatChannelAvatarInitials = chatChannelAvatarInitials;
